function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { UserIconEl } from "common/widgets/user-icon";
import { Placement } from "common/components/tooltip/types";
import { TrackingEventProperty as UserIconTrackingEventProperty } from "common/widgets/user-icon/tracking";
import { TrackedUserIconEl } from "common/widgets/tracked-user-icon";
import { IconSizeType } from "common/constants";
import { TooltipEl } from "common/components/tooltip";
import { getEntityCreatorDisplayName } from "common/report/stores/user-details";
import { getLastViewedStr } from "./util";
import { isTrackedUserItem } from "./types";
import { TrackingEventProperty } from "./tracking";
function getIconEl(user, extraAttrs) {
  if (isTrackedUserItem(user)) {
    return /* @__PURE__ */ jsx(TrackedUserIconEl, { attrs: _objectSpread(_objectSpread({}, user), extraAttrs) });
  } else {
    var _user$name;
    return /* @__PURE__ */ jsx(UserIconEl, { attrs: _objectSpread(_objectSpread(_objectSpread({}, user), extraAttrs), {}, {
      name: (_user$name = user.name) !== null && _user$name !== void 0 ? _user$name : ""
      // guard against passing 'null' or 'undefined' strings
    }) });
  }
}
function OverflowTooltip(_ref) {
  let {
    users,
    extraUsersCount,
    moreText,
    editorUser,
    trackingProps,
    onShowed
  } = _ref;
  if (!users.length) {
    return null;
  }
  const hasLastViewed = users.some((user) => !isTrackedUserItem(user) && !!user.lastViewedUtcSeconds);
  const icons = users.map((user, index) => {
    const commonAttrs = {
      "disable-tooltip": true,
      size: IconSizeType.Small,
      "include-label": true,
      "track-properties": _objectSpread({
        [UserIconTrackingEventProperty.IconType]: index === 0 ? "creator" : "viewer",
        [UserIconTrackingEventProperty.AccessPoint]: "views-overflow"
      }, trackingProps ? {
        [UserIconTrackingEventProperty.Source]: trackingProps[TrackingEventProperty.Source],
        [UserIconTrackingEventProperty.ResourceType]: trackingProps[TrackingEventProperty.ResourceType]
      } : {})
    };
    const rowNodes = [getIconEl(user, commonAttrs)];
    if (hasLastViewed && !isTrackedUserItem(user)) {
      const lastViewedStr = user.lastViewedUtcSeconds ? getLastViewedStr(user.lastViewedUtcSeconds) : "";
      rowNodes.push(/* @__PURE__ */ jsx("div", { sel: ".secondary-text" }, lastViewedStr));
    }
    return /* @__PURE__ */ jsx("div", { sel: ".overflow-entry" }, rowNodes);
  });
  const editorUserName = editorUser && getEntityCreatorDisplayName(editorUser.email, editorUser.name);
  return /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  }, on: {
    showed: onShowed
  }, "data-sentry-element": "TooltipEl", "data-sentry-component": "OverflowTooltip", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".overflow-users-list" }, hasLastViewed && /* @__PURE__ */ jsx("div", { sel: ".overflow-header.overflow-text" }, "Recently Viewed By:"), /* @__PURE__ */ jsx("div", { sel: ".overflow-icons", class: {
    "has-columns": hasLastViewed
  } }, icons), extraUsersCount ? /* @__PURE__ */ jsx("div", { sel: ".overflow-more-text.overflow-text" }, "+ ", extraUsersCount, " ", moreText) : null, editorUser && /* @__PURE__ */ jsx("div", { sel: ".overflow-editor-section" }, /* @__PURE__ */ jsx("div", { sel: ".overflow-text" }, "Last edited ", editorUserName ? "by ".concat(editorUserName, "\n") : "", editorUser.dateStr))));
}
export function template() {
  var _this$attr;
  const maxIcons = this.attr("max-icons-displayed") >= 0 ? this.attr("max-icons-displayed") : 0;
  const allUsers = this.attr("users") || [];
  const usersToShow = allUsers.slice(0, maxIcons).reverse();
  const overflowUsers = allUsers.slice(maxIcons, this.attr("max-icons-total"));
  const extraUsersCount = (_this$attr = this.attr("user-count-override")) !== null && _this$attr !== void 0 ? _this$attr : Math.max(allUsers.length - usersToShow.length, 0);
  const extraOverflowUsersCount = Math.max(extraUsersCount - overflowUsers.length, 0);
  const icons = usersToShow.map((user, index) => {
    return getIconEl(user, {
      "disable-tooltip": this.attr("disable-tooltip"),
      "tooltip-placement": this.attr("tooltip-placement"),
      size: this.attr("size"),
      "track-properties": {
        [UserIconTrackingEventProperty.IconType]: index === 0 ? "creator" : "viewer",
        [UserIconTrackingEventProperty.AccessPoint]: "creator-icon",
        [UserIconTrackingEventProperty.ResourceType]: this.attr("track-properties")[TrackingEventProperty.ResourceType]
      }
    });
  });
  const moreText = extraUsersCount ? /* @__PURE__ */ jsx("div", { sel: ".more-text" }, /* @__PURE__ */ jsx("span", null, "+ ", extraUsersCount), /* @__PURE__ */ jsx(OverflowTooltip, { users: overflowUsers, extraUsersCount: extraOverflowUsersCount, moreText: this.attr("more-text"), editorUser: this.attr("editor-user"), trackingProps: this.attr("track-properties"), onShowed: this.helpers.handleOverflowTooltipShowed })) : null;
  return /* @__PURE__ */ jsx("div", { sel: ".users-list", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".icon-container" }, icons), moreText);
}
